import { useState, useCallback } from 'react'
import type { TooltipPosition } from '@/components/ui/Tooltip'

interface UseTooltipReturn<T> {
  hoveredItem: T | null
  tooltipPosition: TooltipPosition
  handleMouseEnter: (item: T, event: React.MouseEvent) => void
  handleMouseMove: (event: React.MouseEvent) => void
  handleMouseLeave: () => void
  isVisible: boolean
}

export function useTooltip<T>(): UseTooltipReturn<T> {
  const [hoveredItem, setHoveredItem] = useState<T | null>(null)
  const [tooltipPosition, setTooltipPosition] = useState<TooltipPosition>({ x: 0, y: 0 })

  const handleMouseEnter = useCallback((item: T, event: React.MouseEvent) => {
    setHoveredItem(item)
    setTooltipPosition({
      x: event.clientX,
      y: event.clientY,
    })
  }, [])

  const handleMouseMove = useCallback((event: React.MouseEvent) => {
    setTooltipPosition({
      x: event.clientX,
      y: event.clientY,
    })
  }, [])

  const handleMouseLeave = useCallback(() => {
    setHoveredItem(null)
  }, [])

  return {
    hoveredItem,
    tooltipPosition,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    isVisible: hoveredItem !== null,
  }
}
